import { render, staticRenderFns } from "./RsiServerList.vue?vue&type=template&id=2798fcfe&"
import script from "./RsiServerList.vue?vue&type=script&lang=js&"
export * from "./RsiServerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports